import { render, staticRenderFns } from "./guideTagPop.vue?vue&type=template&id=0f72bb45&scoped=true"
import script from "./guideTagPop.vue?vue&type=script&lang=js"
export * from "./guideTagPop.vue?vue&type=script&lang=js"
import style0 from "./guideTagPop.vue?vue&type=style&index=0&id=0f72bb45&prod&lang=less&scoped=true"
import style1 from "./guideTagPop.vue?vue&type=style&index=1&id=0f72bb45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72bb45",
  null
  
)

export default component.exports